export class Person {
    id: number = 0;
    name!: string;
    paternalSurname!: string;
    maternalSurname!: string;
    dateOfBirth!: Date;
    telephone!: string;
    cellPhone!: string;
    email!: string;
    years: number = 0;

    get fullName(): string {
        return `${this.name} ${this.paternalSurname} ${this.maternalSurname}`;
      }
}